import { MyOrderStatusVariant } from 'entities/common/my-ticket/model/types'
import {
  type KyrgyzstanBookingStatus,
  bookingStatusConfig,
} from 'entities/kyrgyzstan'

import type {
  StatusStatusPurchaseTypes,
  StatusToursPurchaseTypes,
} from 'shared/constants'
import {
  StatusPurchase,
  StatusPurchaseExcursion,
  StatusPurchaseExcursionTypes,
  StatusToursPurchase,
} from 'shared/constants'

export const getKyrgyzstanStatus = (
  status: KyrgyzstanBookingStatus,
): MyOrderStatusVariant => {
  const { translationKey, color, background } =
    bookingStatusConfig[status] || bookingStatusConfig.refund_pending

  return { name: translationKey, color, background }
}

export const getAviaStatus = (
  status: StatusStatusPurchaseTypes,
): MyOrderStatusVariant => StatusPurchase[status] || StatusPurchase.PENDING

export const getExcursionsStatus = (
  status: StatusStatusPurchaseTypes,
): MyOrderStatusVariant =>
  StatusPurchaseExcursion[status as StatusPurchaseExcursionTypes] ||
  StatusPurchaseExcursion.PENDING

export const getToursStatus = (
  status: StatusToursPurchaseTypes,
): MyOrderStatusVariant =>
  StatusToursPurchase[status] || StatusToursPurchase.PENDING

export const getBeketStatus = (
  status: StatusStatusPurchaseTypes,
): MyOrderStatusVariant => StatusPurchase[status] || StatusPurchase.PENDING
